import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { AnimatedNumber } from "./AnimatedNumber";
import { Reveal } from "./Reveal";
import { HEADLINE_STAT, SUPPORTING_STATS } from "../data/scholarships";
import { EASE } from "../utils/motion";
import { MapleWatermark } from "./MapleLeaf";
export function ScholarshipGlance() {
  const reduce = useReducedMotion();
  return <section aria-labelledby="scholarship-glance" className="relative mx-auto max-w-[1440px] overflow-hidden px-5 py-24 md:px-9 md:py-36" data-id="element-352" data-mp="2p80bu464l689">
      <MapleWatermark className="-left-10 top-24 h-[30rem] w-[30rem]" tone="text-[#c5233d]/[0.05]" rotate={-8} data-id="element-353" data-mp="2k9p4q177t9tq" />
      <div className="flex items-end justify-between gap-6 border-b border-[#061f38] pb-6" data-id="element-354" data-mp="2fbfabstbed96">
        <p id="scholarship-glance" className="text-xs font-semibold tracking-[0.18em] text-[#bb1e35]" data-id="element-355" data-mp="2b6xsw0afgc1k">SCHOLARSHIPS &amp; RESULTS</p>
        <Link to="/academics/scholarships" className="group hidden items-center gap-2 text-sm font-semibold transition-colors duration-200 hover:text-[#bb1e35] md:inline-flex" data-id="element-356" data-mp="26bidv50ooa3k">
          See every award <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-357" data-mp="3dx2xka8alvfb" />
        </Link>
      </div>

      <div className="grid gap-12 pt-12 lg:grid-cols-12 lg:pt-16" data-id="element-358" data-mp="344orj5a6m2nc">
        <Reveal className="lg:col-span-7" data-id="element-359" data-mp="342u5fnn6c4ho">
          <p className="text-[clamp(3.4rem,9vw,9rem)] font-medium leading-[0.85] tracking-[-0.075em] text-[#061f38]" data-id="element-360" data-mp="3ruj4rnyext84">
            <AnimatedNumber prefix={HEADLINE_STAT.prefix} value={HEADLINE_STAT.value} grouped duration={1.8} data-id="element-361" data-mp="n6odb5ctjt9" />
          </p>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true,
          amount: 0.6
        }} transition={{
          duration: reduce ? 0.01 : 0.9,
          delay: reduce ? 0 : 0.3,
          ease: EASE
        }} className="mt-8 h-[3px] w-24 origin-left bg-[#c5233d]" data-id="element-362" data-mp="3iw75kxjhdn42" />
          <p className="mt-6 max-w-md text-xl leading-8 tracking-[-0.02em]" data-id="element-363" data-mp="hxskxioprki0">{HEADLINE_STAT.label}, {HEADLINE_STAT.context.charAt(0).toLowerCase() + HEADLINE_STAT.context.slice(1)}</p>
        </Reveal>

        <div className="flex flex-col justify-end lg:col-span-4 lg:col-start-9" data-id="element-364" data-mp="87z9chokn5dr">
          <ul className="border-t border-[#dedbd3]" data-id="element-365" data-mp="85ml5ms7zys9">
            {SUPPORTING_STATS.map((stat, i) => <Reveal key={stat.label} delay={0.1 + i * 0.08} data-id="element-366" data-mp="44ksxpwq0mzs" data-mpi={i}>
                <li className="grid grid-cols-[120px_1fr] items-baseline gap-4 border-b border-[#dedbd3] py-5" data-id="element-367" data-mp="3ve9ueoqu3mvx">
                  <span className="text-4xl font-medium tracking-[-0.06em] text-[#bb1e35]" data-id="element-368" data-mp="3qcaphafg4hwv">
                    <AnimatedNumber prefix={stat.prefix} value={stat.value} suffix={stat.suffix} data-id="element-369" data-mp="3lespi9jepd10" />
                  </span>
                  <span className="text-sm leading-6 text-[#4f5963]" data-id="element-370" data-mp="3hfa6jjb5bc0t">
                    <span className="block font-semibold text-[#061f38]" data-id="element-371" data-mp="1jmmdujihcfmt">{stat.label}</span>
                    {stat.context}
                  </span>
                </li>
              </Reveal>)}
          </ul>
          <Link to="/academics/scholarships" className="group mt-10 inline-flex w-fit items-center gap-3 border-b border-[#061f38] pb-2 text-sm font-semibold transition-colors duration-200 hover:border-[#bb1e35] hover:text-[#bb1e35]" data-id="element-372" data-mp="2xh31tjxmnigs">
            Scholarships &amp; results <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-373" data-mp="3b9anafjgnn06" />
          </Link>
        </div>
      </div>
    </section>;
}